import * as Scrivito from 'scrivito';
import { HelperText, Message, WidgetTitle } from '../../utils/translations';
import { ValidationInfo } from '../../utils/type.utils';
import { LinkWidgetAttributes, LinkWidgetId } from './link-widget-definitions';

Scrivito.provideEditingConfig(LinkWidgetId, {
  title: WidgetTitle.LINK,
  titleForContent: (widget) => widget.get(LinkWidgetAttributes.TITLE) as string,
  properties: Object.values(LinkWidgetAttributes),
  attributes: {
    [LinkWidgetAttributes.LINK]: {
      title: HelperText.LINK,
    },
    [LinkWidgetAttributes.ACCESSIBILITY_TEXT]: {
      title: HelperText.ACCESSIBILITY_TEXT,
    },
    [LinkWidgetAttributes.TITLE]: {
      title: HelperText.TITLE,
    },
  },
  validations: [
    [
      LinkWidgetAttributes.LINK,
      (link: Scrivito.Link): ValidationInfo => {
        if (!link) {
          return {
            message: Message.LINK_MISSING,
            severity: 'error',
          };
        }
        if (!link.title() && !link.obj()?.get('title')) {
          return {
            message: Message.LINK_TITLE_MISSING,
            severity: 'error',
          };
        }
        return undefined;
      },
    ],
  ],
  initialContent: {
    [LinkWidgetAttributes.TITLE]: HelperText.LINK_DEFAULT_LABEL,
    [LinkWidgetAttributes.LINK]: new Scrivito.Link({
      url: '#',
      title: HelperText.LINK_DEFAULT_LABEL,
    }),
  },
});
